module.exports = __webpack_public_path__ + "media/img/corporate/company_profile_2-41165f91235e3c0ea29cbf38af8d4199.svg";